<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
    import {isPC} from '@/utils/is-rules'
    export default {
        created(){
           this.isPC()
        },
        methods:{
          isPC(){
            this.$store.dispatch('setIsPC',isPC())
          },
        }
    }
</script>
<style>
html,body,#app{
 margin: 0px;
  height: 100% !important;
}

</style>